import { atom } from 'jotai';
import { $CurrentPOIId } from '@poi/shared/current-poi';
import { $POIInfo } from 'shared/atoms/poi';
import { IPOIInfo, POIInfoUtil } from 'shared/models/poi';

export const $CurrentPOIInfo = atom((get) => {
  const currentPOIId = get($CurrentPOIId);
  return get($POIInfo(currentPOIId));
});

export const $CurrentPOIInfoOrNull = atom((get) => {
  const poiInfo = get($CurrentPOIInfo);
  if (POIInfoUtil.isAvailable(poiInfo)) {
    return poiInfo;
  }
  return null;
});

export const $CurrentPOIInfoAsAvailable = atom((get) => {
  const currentPOIId = get($CurrentPOIId);
  return get($POIInfo(currentPOIId)) as IPOIInfo;
});
